// utils/toast.ts - Create a toast utility
import Swal from "sweetalert2";

export const showToast = {
  success: (message: string) => {
    Swal.fire({
      icon: "success",
      title: message,
      timer: 2000,
      timerProgressBar: true,
    });
  },

  error: (message: string) => {
    Swal.fire({
      icon: "error",
      title: message,
      timer: 3000,
      timerProgressBar: true,
    });
  },

  info: (message: string) => {
    Swal.fire({
      icon: "info",
      title: message,
      timer: 3000,
      timerProgressBar: true,
    });
  },

  warning: (message: string) => {
    Swal.fire({
      icon: "warning",
      title: message,
      timer: 3000,
      timerProgressBar: true,
    });
  },
};

export const showToastNotification = {
  success: (message: string) => {
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "success",
      title: message,
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
    });
  },

  error: (message: string) => {
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "error",
      title: message,
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
    });
  },

  info: (message: string) => {
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "info",
      title: message,
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
    });
  },

  warning: (message: string) => {
    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "warning",
      title: message,
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
    });
  },
};
